import { createAsyncThunk } from "@reduxjs/toolkit";
import AxiosDefaultSetting from "../AxiosDefault";

//get users
export const getAllUsers = createAsyncThunk(
  "usersManagement/getallusers",
  async (data, { rejectWithValue }) => {
    const {
      order_type = "",
      order_by = "",
      page_size = "",
      page = "",
      search_text = "",
      job_position_id = "",
      role_id = "",
      status = "",
      phone = "",
      full_name = "",
      email = "",
      ...rest
    } = data;
    const queryString = new URLSearchParams({
      order_type,
      order_by,
      page_size,
      page,
      search_text,
      job_position_id,
      role_id,
      status,
      phone,
      full_name,
      email,
    }).toString();
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/users?${queryString}`, //endpoint
        data: data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

//Login History
export const getAllLoginHistory = createAsyncThunk(
  "usersManagement/getLoginHistory",
  async ({ id, data }, { rejectWithValue }) => {
    const { order_type, order_by, page_size, page, search_text, ...rest } =
      data;
    const queryString = new URLSearchParams({
      order_type,
      order_by,
      page_size,
      page,
      search_text,
    }).toString();
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/users/${id}/login-history?${queryString}`, //endpoint
        data: data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

//Add user
export const AddUsersApi = createAsyncThunk(
  "usersManagement/Adduser",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "POST",
        url: `/users`, //endpoint
        data: data,
        contentType: "multipart/form-data",
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

//Check existing user
export const CheckUserApi = createAsyncThunk(
  "usersManagement/CheckUser",
  async (email, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/user-by-username/${email}`,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

//Assign existing user to a company
export const AssignUserApi = createAsyncThunk(
  "usersManagement/AssignUser",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "POST",
        url: `/user-company`,
        data: data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

//delete user
export const deleteuserApi = createAsyncThunk(
  "user/delete",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "DELETE",
        url: `/user-company/${id}`, //endpoint
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

//user job postion options

export const getjobpostionsOptions = createAsyncThunk(
  "user/joboptions",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/job-positions`, //endpoint
        //data: data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

//user status chnage
export const userStatus = createAsyncThunk(
  "user/updatedstatus",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "PUT",
        url: `/users/${id}/status`, //endpoint
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
//get user by id
export const userGetByid = createAsyncThunk(
  "user/byid",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/users/${data}`, //endpoint
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
//update use data
export const userDataUpdate = createAsyncThunk(
  "user/updateuser",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "PUT",
        url: `/users/${id}`, //endpoint
        data: data,
        contentType: "multipart/form-data",
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

//add import user api
export const addUserFile = createAsyncThunk(
  "users/file",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "POST",
        url: "/import-users", //endpoint
        data: data,
        contentType: "multipart/form-data",
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

//get user
export const getAllUsersWithoutProfiles = createAsyncThunk(
  "usersManagement/getallusersWithoutProfiles",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/users-without-profiles/${id}`, //endpoint
      });
      return response?.data?.data?.users;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

//add user account and profile
export const addNewUser = createAsyncThunk(
  "usersManagement/addNewUser",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "POST",
        url: `/user-profiles`, //endpoint
        data: data,
        contentType: "multipart/form-data",
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
